import {NgClass}                            from '@angular/common';
import {booleanAttribute, Component, input} from '@angular/core';

@Component({
			   selector   : 'lib-ui-card',
			   imports : [
				   NgClass
			   ],
			   templateUrl: './ui-card.component.html',
			   styleUrl: './ui-card.component.css'
		   })
export class UiCardComponent {

	textTitle = input<string>();
	textDescr = input<string[]>();

	disablePadding = input(false, {transform: booleanAttribute});
	disableTinting = input(false, {transform: booleanAttribute});
	clipPathT = input(false, {transform: booleanAttribute});
	clipPathB = input(false, {transform: booleanAttribute});
}
